// React
import { createContext } from "react"

export const DeleteContext = createContext<{
  value: number[]
  toggleDeleteData: (value: number) => void
}>({
  value: [],
  toggleDeleteData(value) {}
})